import { render, staticRenderFns } from "./LoadingCard.vue?vue&type=template&id=474715b2&scoped=true"
import script from "./LoadingCard.vue?vue&type=script&lang=js"
export * from "./LoadingCard.vue?vue&type=script&lang=js"
import style0 from "./LoadingCard.vue?vue&type=style&index=0&id=474715b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474715b2",
  null
  
)

export default component.exports